import React from "react";
import "./PartnerDirectory.css";
import loanwalleLogo from "../../images/loanwalle_logo_blue_bg.png";
import quaLogo from "../../images/quabrandlogo.png";
import salarywalleLogo from "../../images/salarywalle.svg";
import zeptoLogo from "../../images/zeptologo.png";

const PartnerDirectory = () => {
  const partners = [
    {
      id: 1,
      name: "Loanwalle",
      logo: loanwalleLogo,
      description: "Your trusted partner for quick and easy loans. Get instant loan approvals with competitive interest rates.",
      category: "Lending",
      website: "#"
    },
    {
      id: 2,
      name: "Salarywalle",
      logo: salarywalleLogo,
      description: "Making financial independence simple, fast, and stress-free for salaried professionals.",
      category: "Salary Advance",
      website: "#"
    },
    {
      id: 3,
      name: "Qua",
      logo: quaLogo,
      description: "Premium financial solutions tailored to meet your unique business and personal needs.",
      category: "Financial Services",
      website: "#"
    },
    {
      id: 4,
      name: "Zepto",
      logo: zeptoLogo,
      description: "Innovative fintech solutions for modern businesses and individuals.",
      category: "Fintech",
      website: "#"
    }
  ];

  return (
    <div className="partner-directory-page">
      <div className="partner-hero">
        <h1>Partner Directory</h1>
        <p>Explore our trusted network of financial partners and lending institutions</p>
      </div>
      
      <div className="partner-directory-container">
        <div className="partner-grid">
          {partners.map((partner) => (
            <div key={partner.id} className="partner-card">
              <div className="partner-logo-wrapper">
                <img src={partner.logo} alt={partner.name} className="partner-logo" />
              </div>
              <div className="partner-info">
                <div className="partner-category">{partner.category}</div>
                <h3 className="partner-name">{partner.name}</h3>
                <p className="partner-description">{partner.description}</p>
                <a href={partner.website} className="partner-link" target="_blank" rel="noopener noreferrer">
                  Learn More →
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default PartnerDirectory;

